export default function isEmptyObject(obj) {
	return Object.prototype.toString.call(obj) === "[object Object]" && Object.keys(obj).length === 0;
}



// WEBPACK FOOTER //
// ./src/shared/util/isEmptyObject.js